import React from 'react';
import { View, Pressable, Share, Platform, ScrollView } from 'react-native';
import { Text } from '@/components/ui/text';
import { useAuth } from '@/hooks/use-auth';
import { getProfileShareUrl } from '@/utils/share-urls';

interface FriendSeedingScreenProps {
  onSkip: () => void;
  onNext: () => Promise<void>;
  isAdvancing: boolean;
}

export function FriendSeedingScreen({ onSkip, onNext, isAdvancing }: FriendSeedingScreenProps) {
  const { user } = useAuth();
  const shareUrl = getProfileShareUrl(user?.username ?? '');

  const handleShare = async () => {
    try {
      if (Platform.OS === 'web') {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        await Share.share({ message: `Join me on Flavrly! ${shareUrl}`, url: shareUrl });
      }
    } catch {
      // Share cancelled or failed - non-fatal
    }
  };

  return (
    <View className="flex-1 px-6 pt-4">
      <ScrollView className="flex-1" showsVerticalScrollIndicator={false} contentContainerStyle={{ flexGrow: 1 }}>
        <Text className="text-xl font-bold text-foreground mb-2">Invite Friends</Text>
        <Text className="text-sm text-muted-foreground mb-6">
          Flavrly is better with friends. Share your profile link so they can find you.
        </Text>

        <View className="items-center mb-8">
          <View className="bg-surface-secondary rounded-xl p-6 items-center w-full">
            <Text className="text-sm text-muted-foreground mb-2">Your profile link</Text>
            <Text className="text-sm text-foreground font-mono mb-4" numberOfLines={1}>
              {shareUrl}
            </Text>

            <Pressable
              onPress={handleShare}
              accessibilityLabel="Share Link"
              className="bg-primary rounded-lg py-2 px-6"
            >
              <Text className="text-primary-foreground text-sm font-semibold">Share Link</Text>
            </Pressable>
          </View>
        </View>
      </ScrollView>

      <Pressable
        onPress={onSkip}
        accessibilityLabel="Skip"
        className="rounded-lg py-3 px-8 mb-4"
      >
        <Text className="text-muted-foreground text-base text-center">
          Skip for now
        </Text>
      </Pressable>
    </View>
  );
}
